import {getQuarterFromDate} from 'ng2-app/util/borrowerValues/getQuarterFromDate';

/**
 * util to return the alias format of quarterly revenue
 *
 * @param startDateTime
 */
export function getFormattedQuarterYear(startDateTime) {
  const startDate = new Date(startDateTime);
  const quarter = getQuarterFromDate(startDate);
  const year = startDate.getFullYear();

  return `quarterlyRevenue${year}Q${quarter}`;
}
